module.exports = __webpack_public_path__ + "assets/img/icon_game.08eb1ae8.png";